import { extendTheme } from '@chakra-ui/react';

import { config } from '@/theme/config';
import foundations from '@/theme/foundations';
import { semanticTokens } from '@/theme/semantic-tokens';
import { styles } from '@/theme/styles';

import * as components from './components';
import { shadows } from './foundations/shadows';

export const theme = extendTheme({
  config,
  styles,
  ...foundations,
  semanticTokens,
  components: {
    ...components,
  },
  shadows,
});
